import axios, { AxiosError } from "axios";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { parseTaskModel } from "../../task/model";

class ReferralFormApi {

    public async deleteReferralForm(customerId: string, ohCaseId: string, reason: string): Promise<TaskModel>  {
        try {
            const data = {
                reason
            };

            const result = await axios.post(`/api/case/${customerId}/${ohCaseId}/DeleteReferralForm`, data);

            return parseTaskModel(result.data);
        } catch (e) {
            const axiosError = e as AxiosError<string>;
            if (axiosError?.response?.status === 400) {
                throw new Error(axiosError.response.data);
            }

            throw e;
        }
    }

    public async deleteReferralFormDocument(customerId: string, caseId: string, id: string, reason: string): Promise<any>  {
        try {
            const data = {
                reason
            };

            const result = await axios.post(`/api/referral/customer/${customerId}/${caseId}/document/${id}/delete`, data);

            return parseTaskModel(result.data);
        } catch (e) {
            const axiosError = e as AxiosError<string>;
            if (axiosError?.response?.status === 400) {
                throw new Error(axiosError.response.data);
            }

            throw e;
        }
    }
}

export default new ReferralFormApi();
